export const DEALER_ORDERS_INVALIDATED_EVENT =
  "cfmoto:dealer-orders-invalidated";

export function dispatchDealerOrdersInvalidated(
  target: Pick<EventTarget, "dispatchEvent">
): void {
  target.dispatchEvent(new Event(DEALER_ORDERS_INVALIDATED_EVENT));
}
